import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { CustomLink } from '@/components/CustomLink/CustomLink';

export const Box = styled.div<{
  $noPadding?: boolean;
  $hasPaddingTop?: boolean;
}>`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: ${({ $noPadding }) => ($noPadding ? '0' : '15px 0')};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '15px')};
  }

  ${({ $hasPaddingTop }) =>
    !$hasPaddingTop &&
    css`
      padding-top: 0;
    `}
`;

export const TitleWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  margin-bottom: 20px;
`;

export const Title = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 16px;
  padding: 5px 0;
`;

export const AllAdsLink = styled(CustomLink)`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-decoration: underline;
  font-size: 15px;
`;
